import { getAxiosInstance } from "../../../api";

export const createDeliveryChallan = async (body) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(`delivery/delivery-challan-upload`, body);
    return res;
  } catch (error) {
    return error.response.data;
  }
};

export const updateDeliveryChallanStatus = async (id, reason) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(
      `delivery/update-delivery-challan-status?id=${id}`,
      { reason },
    );
    return res;
  } catch (error) {
    return error.response.data;
  }
};
export const getDeliveryChallanPrint = async (id) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.get(`delivery/create-delivery-challan?id=${id}`);
    return res;
  } catch (error) {
    return error.response.data;
  }
};
